// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { qnaApi } from '../apis/qna.api';

// action
import { actions } from '../actions/qna.action';

import { COOKIE_USER_FILE_ID, cookieStorage } from 'services';

/**
 * 공지사항 검색 (공백 검색시 전체 리스트)
 * */
export const getQnaList = createAsyncThunk(
  actions.getQnaSearchAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.getQnaSearch(data);
      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;

      if (res || code === 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList,
          resultObject,
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
/**
 * 공지사항 상세 조회
 * */
export const getQnaDetail = createAsyncThunk(
  actions.getQnaDetailAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.getQnaDetail(data);

      if (!res) return;
      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;
      if (!res || !resultList || !resultObject || code !== 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList,
          resultObject,
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
/**
 * 공지사항 등록하기
 **/
export const postQna = createAsyncThunk(
  actions.postQnaAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.postQna(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;

      cookieStorage.setCookie(COOKIE_USER_FILE_ID, resultObject.QnaId);
      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
/**
 * 공지사항 수정
 **/
export const getUpdateQna = createAsyncThunk(
  actions.getQnaModifyAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.updateQna(data);

      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;
      if (!res || !resultList || !resultObject || code !== 200) {
        return fulfillWithValue({
          code,
          isSuccess,
          message,
          resultList,
          resultObject,
          totalMap
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 공지사항 삭제
 * */
export const deleteQna = createAsyncThunk(
  actions.deleteQnaAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.deleteQna(data);

      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
/**
 * 공지사항 사진 조회
 * */
export const getQnaPic = createAsyncThunk(
  actions.getQnaPicDownload,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.deleteQna(data);

      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getQnaComment = createAsyncThunk(
  actions.getQnaCommentAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.postQnaComment(data);

      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getQnaCommentModify = createAsyncThunk(
  actions.getQnaCommentModifyAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.updateQnaComment(data);

      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getQnaCommentDelete = createAsyncThunk(
  actions.getQnaCommentDeleteAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await qnaApi.deleteQnaComment(data);

      const { code, isSuccess, message, resultList, resultObject, totalMap } =
        res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
